export const SELL_OPERATION = "بيع";
export const BUY_OPERATION = "شراء";
export const WAITING_FOR_SHIPPING = "منتظر الشحن";
export const WAITING_FOR_SHIPPING_STATUS_DESCRIPTION =
  "يقوم البائع بتوصيل المنتج الي المشتري";
export const WAITING_FOR_INSPECTION = "جاري الفحص";
export const WAITING_FOR_INSPECTION_STATUS_DESCRIPTION =
  "يقوم المشتري بفحص المنتج";
export const ESCALATION_STATUS = "جاري التحكيم";
export const ESCALATION_STATUS_DESCRIPTION_CUSTOMER =
  "قام المشتري بتصعيد المعامله لوفي";
export const ESCALATION_STATUS_DESCRIPTION_SELLER = "قام البائع بتصعيد الصفقة";

export const ACTIVE_STATUS = "نشط";
export const ACTIVE_STATUS_DESCRIPTION = "قم بمشاركة الرابط مع المشتري";

export const COMPLETED_STATUS = "عملية ناجحة";
export const COMPLETED_STATUS_DESCRIPTION = "تم تحويل قيمة المعاملة للبائع";

export const EXCEPTIONAL_COMPLETED_STATUS = "عملية ناجحة";
export const EXCEPTIONAL_COMPLETED_STATUS_DESCRIPTION =
  "تم تحويل قيمة المعاملة";

export const PENDING_APPROVAL = "انتظار تأكيد الدفع";
export const PENDING_APPROVAL_DESCRIPTION =
  "تم دفع هذه العملية عن طريق تحويل بنكي.";
export const CANCELLED_STATUS = "عملية ملغية";
export const REQUIRED_AMOUNT = "المبلغ المطلوب";

export const PENDING_CASHOUT = "جاري تنفيذ عملية التحويل";
export const PENDING_CASHOUT_DESCRIPTION =
  "بانتظار تأكيد التحويل، يأخذ هذا الإجراء بضع دقائق";

export const FAILED_CASH_OUT = "تم رفض عملية التحويل";
export const FAILED_CASH_OUT_DESC = "يمكنك إجراء عملية تحويل جديدة.";

export const ITEM_ACCEPTED_STATUS = "تمت العملية بنجاح";
export const ITEM_ACCEPTED_STATUS_DESCRIPTION =
  "سنقوم بتحويل قيمة المعاملة للبائع";

export const WAITING_FOR_SETTLEMENT_CLOSE_STATUS =
  "بانتظار تسوية المعاملة للغلق";
export const WAITING_FOR_SETTLEMENT_RESOLVE_STATUS =
  "بانتظار تسوية المعاملة للحل";

export const WAITING_SETTLEMENT_STATUS = "بانتظار تسوية المعاملة";
export const WAITING_SETTLEMENT_STATUS_DESCRIPTION =
  "تم دفع هذه المعاملة عن طريق تابي، يتم تسوية المعاملة خلال المدة من 7 إلى 14 يوم من بدء شراء المعاملة.";

export const WAITING_FOR_APPROVAL_TITLE = "انتظار تأكيد الدفع";

export const RESOLVED_STATUS = "تم حل المشلكة";
export const RESOLVE_BUYER_REFUND_STATUS_DESCRIPTION =
  "سنقوم برد المعاملة للمشتري";

export const RESOLVE_SELLER_REALSE_STATUS_DESCRIPTION =
  "سنقوم بتحويل قيمة المعاملة للبائع";

export const CLOSE_WAITING_FOR_DELIVERY = "إرجاع المبلغ إلي المشتري";

export const CONFIRM_DELIVERY = "تأكيد استلام المنتج";

export const CONFIRM_INSPECTION = "تأكيد فحص المنتج";

export const CLOSED_STATUS = "انتهت المعاملة";
export const CLOSED_RELEASE_DESCRIPTION = "قمنا بتحويل قيمة المعاملة للبائع";
export const CLOSED_REFUND_DESCRIPTION = "قمنا برد قيمة المعاملة للمشتري";
export const CANCELED_TRANSACTION = "معاملة ملغية";
export const CANCELLED_STATUS_TITLE = "تم إلغاء المعاملة";
export const CANCELLED_STATUS_DESCRIPTION =
  "قمت بإلغاء المعاملة، وسيتم تحويل الأموال للمشتري.";
export const CONTRACT_REJECTED = "طلب مرفوض";
export const PENDING_PAYMENT_VERIFICATION = "انتظار تأكيد الدفع";
export const OUT_OF_STOCK_STATUS = "تم نفاذ الكمية";
export const READY_FOR_CASHOUT_STATUS = "تسوية المعاملة";
export const READY_FOR_CASHOUT_STATUS_DESCRIPTION =
  "فريق وفي يقوم بمراجعة وتسوية المعاملة";
export const CASHOUT_APPROVED_STATUS = "تحويل الأموال";
export const CASHOUT_APPROVED_STATUS_DESCRIPTION =
  "جارٍ تحويل الأموال بناءً على قرار التسوية";
